export const FETCH_PUBLIC_BLOG_REQUEST = 'FETCH_PUBLIC_BLOG_REQUEST'
export const FETCH_PUBLIC_BLOG_SUCCESS = 'FETCH_PUBLIC_BLOG_SUCCESS'
export const FETCH_PUBLIC_BLOG_FAIL = 'FETCH_PUBLIC_BLOG_FAIL'

export const ADD_PRIVATE_BLOG_REQUEST = 'ADD_PRIVATE_BLOG_REQUEST'
export const ADD_PRIVATE_BLOG_SUCCESS = 'ADD_PRIVATE_BLOG_SUCCESS'
export const ADD_PRIVATE_BLOG_FAIL = 'ADD_PRIVATE_BLOG_FAIL'
export const ADD_PRIVATE_BLOG_RESET = 'ADD_PRIVATE_BLOG_RESET'

export const FETCH_USER_PRIVATE_BLOG_REQUEST = 'FETCH_USER_PRIVATE_BLOG_REQUEST'
export const FETCH_USER_PRIVATE_BLOG_SUCCESS = 'FETCH_USER_PRIVATE_BLOG_SUCCESS'
export const FETCH_USER_PRIVATE_BLOG_FAIL = 'FETCH_USER_PRIVATE_BLOG_FAIL'

export const FETCH_PRIVATE_BLOG_BY_ID_REQUEST = 'FETCH_PRIVATE_BLOG_BY_ID_REQUEST'
export const FETCH_PRIVATE_BLOG_BY_ID_SUCCESS = 'FETCH_PRIVATE_BLOG_BY_ID_SUCCESS'
export const FETCH_PRIVATE_BLOG_BY_ID_FAIL = 'FETCH_PRIVATE_BLOG_BY_ID_FAIL'

// export const UPDATE_PRIVATE_BLOG_REQUEST = 'UPDATE_PRIVATE_BLOG_REQUEST'
// export const UPDATE_PRIVATE_BLOG_SUCCESS = 'UPDATE_PRIVATE_BLOG_SUCCESS'
// export const UPDATE_PRIVATE_BLOG_FAIL = 'UPDATE_PRIVATE_BLOG_FAIL'

export const DELETE_PRIVATE_BLOG_REQUEST = 'DELETE_PRIVATE_BLOG_REQUEST'
export const DELETE_PRIVATE_BLOG_SUCCESS = 'DELETE_PRIVATE_BLOG_SUCCESS'
export const DELETE_PRIVATE_BLOG_FAIL = 'DELETE_PRIVATE_BLOG_FAIL'
export const DELETE_PRIVATE_BLOG_RESET = 'DELETE_PRIVATE_BLOG_RESET'

export const ADD_PUBLIC_BLOG_REQUEST = 'ADD_PUBLIC_BLOG_REQUEST'
export const ADD_PUBLIC_BLOG_SUCCESS = 'ADD_PUBLIC_BLOG_SUCCESS'
export const ADD_PUBLIC_BLOG_FAIL = 'ADD_PUBLIC_BLOG_FAIL'
export const ADD_PUBLIC_BLOG_RESET = 'ADD_PUBLIC_BLOG_RESET'

export const FETCH_USER_PUBLIC_BLOG_REQUEST = 'FETCH_USER_PUBLIC_BLOG_REQUEST'
export const FETCH_USER_PUBLIC_BLOG_SUCCESS = 'FETCH_USER_PUBLIC_BLOG_SUCCESS'
export const FETCH_USER_PUBLIC_BLOG_FAIL = 'FETCH_USER_PUBLIC_BLOG_FAIL'

export const FETCH_PUBLIC_BLOG_BY_ID_REQUEST = 'FETCH_PUBLIC_BLOG_BY_ID_REQUEST'
export const FETCH_PUBLIC_BLOG_BY_ID_SUCCESS = 'FETCH_PUBLIC_BLOG_BY_ID_SUCCESS'
export const FETCH_PUBLIC_BLOG_BY_ID_FAIL = 'FETCH_PUBLIC_BLOG_BY_ID_FAIL'

export const UPDATE_PUBLIC_BLOG_REQUEST = 'UPDATE_PUBLIC_BLOG_REQUEST'
export const UPDATE_PUBLIC_BLOG_SUCCESS = 'UPDATE_PUBLIC_BLOG_SUCCESS'
export const UPDATE_PUBLIC_BLOG_FAIL = 'UPDATE_PUBLIC_BLOG_FAIL'
export const UPDATE_PUBLIC_BLOG_RESET = 'UPDATE_PUBLIC_BLOG_RESET'

export const DELETE_PUBLIC_BLOG_REQUEST = 'DELETE_PUBLIC_BLOG_REQUEST'
export const DELETE_PUBLIC_BLOG_SUCCESS = 'DELETE_PUBLIC_BLOG_SUCCESS'
export const DELETE_PUBLIC_BLOG_FAIL = 'DELETE_PUBLIC_BLOG_FAIL'
export const DELETE_PUBLIC_BLOG_RESET = 'DELETE_PUBLIC_BLOG_RESET'

export const FETCH_USER_SAVED_BLOG_REQUEST = 'FETCH_USER_SAVED_BLOG_REQUEST'
export const FETCH_USER_SAVED_BLOG_SUCCESS = 'FETCH_USER_SAVED_BLOG_SUCCESS'
export const FETCH_USER_SAVED_BLOG_FAIL = 'FETCH_USER_SAVED_BLOG_FAIL'

export const BLOG_SAVE_STATUS_CHANGE_REQUEST = 'BLOG_SAVE_STATUS_CHANGE_REQUEST'
export const BLOG_SAVE_STATUS_CHANGE_SUCCESS = 'BLOG_SAVE_STATUS_CHANGE_SUCCESS'
export const BLOG_SAVE_STATUS_CHANGE_FAIL = 'BLOG_SAVE_STATUS_CHANGE_FAIL'
export const BLOG_SAVE_STATUS_CHANGE_RESET = 'BLOG_SAVE_STATUS_CHANGE_RESET'

export const BLOG_LIKE_STATUS_CHANGE_REQUEST = 'BLOG_LIKE_STATUS_CHANGE_REQUEST'
export const BLOG_LIKE_STATUS_CHANGE_SUCCESS = 'BLOG_LIKE_STATUS_CHANGE_SUCCESS'
export const BLOG_LIKE_STATUS_CHANGE_FAIL = 'BLOG_LIKE_STATUS_CHANGE_FAIL'
export const BLOG_LIKE_STATUS_CHANGE_RESET = 'BLOG_LIKE_STATUS_CHANGE_RESET'


